import { CapitalizationStatusEnum } from "../../../../enums/capitalization-status.enum";
import { CreateCapitalizationType } from "../types/CreateCapitalizationInitialValuesTypes";

export const CreateCapitalizationInitialInfo: CreateCapitalizationType =
{
  "lessorName": "",
  "lessorDocument": "",
  "locationType": "",
  "property": {
    "country": "",
    "state": "",
    "city": "",
    "district": "",
    "street": "",
    "number": "",
    "complement": "",
    "zipCode": "",
    "propertyType": "",
    "hasComplement": false
  },
  "tenant": {
    "document": "",
    "name": "",
    "nationality": "Brasileiro(a)",
    "gender": "",
    "motherName": "",
    "maritalStatus": "",
    "politicallyExposedPerson": "",
    "identityDocument": "",
    "identityDocumentIssuance": "",
    "identityDocumentUf": "",
    "identityDocumentDate": "",
    "profession": "",
    "professionCode": "",
    "cellphone": "",
    "email": "",
    "companyRepresentativeName": "",
    "companyRepresentativeDocument": "",
    "companyRepresentativeCellphone": "",
    "companyRepresentativeEmail": "",
    "type": "",
    "stateRegistration": "",
    "municipalRegistration": "",
    "constitutionDate": undefined,
    "hasStateRegistration": true,
    "hasMunicipalRegistration": true,
  },
  multiplier: 0,
  insurerId: "",
  estateId: "",
  status:  CapitalizationStatusEnum.inIssue,
  startVigency: undefined,
  endVigency: undefined,
}
